import React, { ReactNode } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

/** A titled block of the context panel, separated from the next by a divider. */
export function PanelSection({
  title,
  action,
  children,
  testId,
}: {
  title: string;
  /** Rendered at the right of the title (a refresh button, a count). */
  action?: ReactNode;
  children: ReactNode;
  testId?: string;
}) {
  return (
    <>
      <Box sx={{ px: 2, py: 1.5 }} data-testid={testId}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1.5 }}>
            {title}
          </Typography>
          {action}
        </Stack>
        {children}
      </Box>
      <Divider />
    </>
  );
}
